// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app[data-v-229bd940]{min-height:100%;display:flex;flex-direction:column}.nuxt-wrap[data-v-229bd940]{opacity:1 !important}.main[data-v-229bd940]{display:flex;flex-direction:column;flex-grow:1;padding-bottom:28px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
